import HotGlue from './hotglue';

var AppState = new HotGlue({

  name: "AppState",

  initial: {
    user: undefined,
    loggedIn: false,
    userSettings: [],
    userPremium: null,
    orgs: [],
    selectedOrg: null,
    subscription: null,
    paymentMethod: null,
    charges: [],
    nextInvoice: null,

    orgSubscription: null,
    orgPaymentMethod: null,
    orgCharges: [],
    orgNextInvoice: null,
    collaborators: [],
    invites: []
  },

  useLocalStorage: false,

  actions: {

    login: (state, user) => {state.user = user;},
    logout: (state) => {state.user = undefined;},

    setUser: (state, user) => { state.user = user; },
    setUserSettings: (state, settings) => { state.userSettings = settings; },
    setUserPremium: (state, premium) => { state.userPremium = premium; },
    setOrgs: (state, orgs) => { state.orgs = orgs; },
    setPaymentMethod: (state, paymentMethod) => {state.paymentMethod = paymentMethod; },
    setCharges: (state, charges) => {state.charges = charges; },
    setNextInvoice: (state, nextInvoice) => {state.nextInvoice = nextInvoice; },
    setSubscription: (state, subscription) => {state.subscription = subscription; },
    selectOrg: (state, org) => { state.selectedOrg = org; },
    setCollaborators: (state, collaborators) => { state.collaborators = collaborators; },
    setInvites: (state, invites) => { state.invites = invites; },

    setOrgSubscription: (state, orgSubscription) => {state.orgSubscription = orgSubscription; },
    setOrgPaymentMethod: (state, orgPaymentMethod) => {state.orgPaymentMethod = orgPaymentMethod; },
    setOrgCharges: (state, orgCharges) => {state.orgCharges = orgCharges; },
    setOrgNextInvoice: (state, orgNextInvoice) => {state.orgNextInvoice = orgNextInvoice; }

  }


});

export default AppState;


// WEBPACK FOOTER //
// ./src/state/AppState.js